import { cn } from "@lxp-app/utils/cn";
import React from "react";

interface watermark {
  rowCount?: number;
  colCount?: number;
  waterMarkText: string;
  className?: string;
  textStyle?: string;
}

const WaterMark: React.FC<watermark> = ({
  rowCount = 5,
  colCount = 4,
  waterMarkText,
  className,
  textStyle
}) => {
  return (
    <div className="w-full opacity-[3%] bg-white">
      <div
        className={cn(
          `grid grid-cols-${colCount} grid-rows-${rowCount} absolute top-0 left-0 w-screen h-screen overflow-hidden gap-y-28 pointer-events-none`,
          className
        )}
      >
        {Array.from({ length: rowCount * colCount * 10 }).map((_, index) => (
          <span
            className={cn(
              "font-semibold text-4xl my-28 -rotate-[30deg]",
              textStyle
            )}
          >
            {waterMarkText}
          </span>
        ))}
      </div>
    </div>
  );
};

export default WaterMark;
